"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hostname = exports.MacAddress = exports.HTTPSUrl = exports.Email = void 0;
const effect_1 = require("effect");
const NAMESPACE = 'Net';
exports.Email = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^(?!\.)(?!.*\.\.)([\p{L}A-Z0-9!#$%&'*+\-/=?^_`{|}~.]*)[\p{L}A-Z0-9!#$%&'*+\-/=?^_`{|}~]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/iu, {
    arbitrary: () => FC => FC.oneof(FC.emailAddress(), FC.constantFrom('josé@example.com', 'müller@example.com', '用户@example.com')),
})).annotations({ identifier: `${NAMESPACE}.Email` });
exports.HTTPSUrl = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^https:\/\/.*$/)).annotations({
    identifier: `${NAMESPACE}.HTTPSUrl`,
});
exports.MacAddress = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^[0-9a-f]{2}(:[0-9a-f]{2}){5}$/)).annotations({
    identifier: `${NAMESPACE}.MacAddress`,
});
exports.Hostname = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^(?!.{254,})((?!-)[A-Za-z0-9-]{1,63}(?<!-)\.)+[A-Za-z]{2,63}$/, {
    arbitrary: () => FC => FC.constantFrom('example.com', 'dev.example.com', 'dashboard.dev.example.com'),
})).annotations({
    identifier: `${NAMESPACE}.Hostname`,
    description: 'A fully qualified DNS hostname, without scheme, port or path.',
    examples: ['example.com', 'dev.example.com', 'dashboard.dev.example.com'],
});
//# sourceMappingURL=net.js.map